/** MP5, as a thing you can carry. The gun itself is `sim/weapons/guns/mp5.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const MP5_ITEM = {
  id: 'mp5',
  kind: 'weapon',
  label: 'MP5',
  description:
    'Closed-bolt 9 mm that stays on target. The corridor gun of every armoury that still has one.',
  rarity: 'common',
  weightKg: 3.0,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'mp5',
} as const satisfies WeaponItem;
